import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMemo, useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { getSearchPlaceholderText } from '../../../utils/searchPlaceholderUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ANIMATION_DURATION = 300;
const MAX_WIDTH = 442;
const SearchInputWrapper = styled.div.withConfig({
  displayName: "AssociationsSearchInput__SearchInputWrapper",
  componentId: "cevrg4-0"
})(["max-height:", ";max-width:", "px;opacity:", ";transform:", ";transition:max-height ", "ms ease-out,opacity 200ms ease-out,transform ", "ms ease-out;overflow:", ";"], ({
  isVisible
}) => isVisible ? '56px' : '0', MAX_WIDTH, ({
  isVisible
}) => isVisible ? '1' : '0', ({
  isVisible,
  theme
}) => isVisible ? 'translateY(0)' : `translateY(-${theme.space['250']})`, ANIMATION_DURATION, ANIMATION_DURATION, ({
  isVisible
}) => isVisible ? 'visible' : 'hidden');
function AssociationSearchInput({
  showSearchInput,
  value,
  onChange,
  objectTypeId
}) {
  const inputRef = useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const handleInputChange = e => {
    onChange(e.target.value);
  };
  const placeholderText = useMemo(() => getSearchPlaceholderText(objectTypeId), [objectTypeId]);

  // Focus search input when first shown
  useEffect(() => {
    if (showSearchInput && inputRef.current) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }
  }, [showSearchInput]);

  // Show tooltip only on hover instead of all focus events like when first opened, which is excessive
  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };
  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };
  return /*#__PURE__*/_jsx(SearchInputWrapper, {
    isVisible: showSearchInput,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: placeholderText,
      placement: "left",
      open: isTooltipOpen,
      children: /*#__PURE__*/_jsx(SearchInput, {
        inputRef: inputRef,
        placeholder: placeholderText,
        onChange: handleInputChange,
        value: value,
        marginBlockStart: "300",
        maxInlineSize: `${MAX_WIDTH}`
      })
    })
  });
}
export default AssociationSearchInput;